import React from "react";
import Flagship from "../../core/flagship";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router";
import IoProductAddModal from "../modals/IoProductAddModal";
import IoProductAdvisrAddModal from "../modals/IoProductAdvisrAddModal";
import IoProductViewModal from "../modals/IoProductViewModal";
import IoProductEditModal from "../modals/IoProductEditModal";
import IoProductAssignModal from "../modals/IoProductAssignModal";
import {
  getFormattedValue,
  empty,
  getServiceNiceName,
} from "../../utils/helpers";
import moment from "moment";
import {
  Divider,
  Header,
  Loader,
  Card,
  Button,
  Icon,
  Label,
  Image,
  Dropdown,
  Table,
  Popup,
} from "semantic-ui-react";
import { bindActionCreators } from "redux";
import * as actions from "../../actions/appActions";

class IoProductBox extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
    this.latestIoProductsRequestId = 0;
    this.unmounted = false;
    this.getIoProducts = this.getIoProducts.bind(this);
    this.onAddNew = this.onAddNew.bind(this);
    this.cancelAddNew = this.cancelAddNew.bind(this);
    this.closeModals = this.closeModals.bind(this);
    this.renderIoProducts = this.renderIoProducts.bind(this);
    this.onIoProductAddModalChange = this.onIoProductAddModalChange.bind(this);
    this.onViewIoProduct = this.onViewIoProduct.bind(this);
    this.onEditIoProduct = this.onEditIoProduct.bind(this);
    this.onAddIoProduct = this.onAddIoProduct.bind(this);
    this.onUpdateIoProduct = this.onUpdateIoProduct.bind(this);
    this.onChangeAssignee = this.onChangeAssignee.bind(this);
    this.swapToEdit = this.swapToEdit.bind(this);
    this.swapToView = this.swapToView.bind(this);
    this.renderAddIoProductModal = this.renderAddIoProductModal.bind(this);
    this.renderAssignIoProductModal =
      this.renderAssignIoProductModal.bind(this);
    this.renderCriticalData = this.renderCriticalData.bind(this);
    this.onChangeProductStatus = this.onChangeProductStatus.bind(this);
    this.onChangeProductStatusCancel =
      this.onChangeProductStatusCancel.bind(this);
    this.onChangeProductStatusConfirm =
      this.onChangeProductStatusConfirm.bind(this);
    this.checkForIoStatusChanges = this.checkForIoStatusChanges.bind(this);
    this.maybeOpenIoProduct = this.maybeOpenIoProduct.bind(this);
    this.changeViewAs = this.changeViewAs.bind(this);
    this.renderAsTable = this.renderAsTable.bind(this);
  }

  getInitialState() {
    return {
      loading: true,
      ioProducts: [],
      newIoProductName: "",
      newIoProductService: null,
      newIoProductServiceNiceName: null,
      editPricingFields: [],
      addingIoProduct: false,
      viewingIoProduct: false,
      editingIoProduct: false,
      updatingPricing: false,
      editingAssignee: false,
      newIoProductData: [],
      editing: {},
      refreshing: false,
      savingIoProductChange: false,
    };
  }

  componentDidMount() {
    this.unmounted = false;
    this.getIoProducts();
  }

  componentWillReceiveProps(nextProps) {
    const recordChanged = this.props.recordId !== nextProps.recordId;
    const viewingChildChanged = nextProps.viewingChild !== this.props.viewingChild;

    if (recordChanged) {
      this.props.updateLineItems([]);
      this.setState({
        loading: true,
        ioProducts: [],
        viewingIoProduct: false,
        editingIoProduct: false,
        updatingPricing: false,
        editingAssignee: false,
        refreshing: false,
      });
      this.getIoProducts(nextProps.recordId);
    } else if (viewingChildChanged) {
      this.maybeOpenIoProduct(nextProps);
    }
    if (
      nextProps.accessLevel === 2 &&
      ((this.props.recordStatus === "draft" &&
        nextProps.recordStatus === "publish") ||
        (this.props.recordStatus === "draft" &&
          nextProps.recordStatus === "pending"))
    ) {
      let getIoProducts = this.getIoProducts;
      Flagship.post(
        "io-product/submit-all/" + nextProps.recordId,
        {},
        function () {
          getIoProducts(nextProps.recordId);
        },
      );
    }
  }

  componentWillUnmount() {
    this.unmounted = true;
    this.latestIoProductsRequestId += 1;
  }

  maybeOpenIoProduct(nextProps = false) {
    let propsToConsider = nextProps === false ? this.props : nextProps;
    let self = this;
    let viewingNow = false;

    this.state.ioProducts.map(function (item) {
      if (item.io_product_key === propsToConsider.viewingChild) {
        viewingNow = true;

        self.setState({
          viewingIoProduct: item,
        });
      }
    });
    if (viewingNow !== true) {
      this.setState({
        viewingIoProduct: false,
      });
    }
  }

  getPlatforms() {
    return new Promise((resolve) => {
      Flagship.get(
        "register-campaign-options",
        {},
        function (response) {
          if (response.data.success === true) {
            resolve(response.data.options.platforms);
          } else {
            resolve([]);
          }
        },
        function () {
          resolve([]);
        },
      );
    });
  }

  getCampaigns(productId) {
    return new Promise((resolve) => {
      Flagship.get(
        "registered-campaigns",
        { io_product_id: productId },
        function (response) {
          if (response.data.success === true) {
            resolve(response.data.results);
          } else {
            console.error("Failed to get campaigns.");
            resolve([]);
          }
        },
        function (err) {
          console.error(err);
          resolve([]);
        },
      );
    });
  }

  getIoProducts(recordId = this.props.recordId) {
    let self = this;
    this.latestIoProductsRequestId += 1;
    const requestId = this.latestIoProductsRequestId;

    Flagship.get(
      "io-products/" + recordId,
      {},
      function (response) {
        if (
          self.unmounted === true ||
          requestId !== self.latestIoProductsRequestId ||
          self.props.recordId !== recordId
        ) {
          return;
        }

        if (response.data.success === true) {
          let ioProducts = Array.isArray(response.data.results)
            ? response.data.results
            : [];
          ioProducts.map(function (item) {
            if (!empty(item.flights)) {
              item.flights.sort((a, b) =>
                moment(a.startDate).unix() > moment(b.startDate).unix()
                  ? 1
                  : -1,
              );
            }
          });

          self.setState(
            {
              ioProducts,
              loading: false,
              refreshing: false,
            },
            function () {
              self.checkForIoStatusChanges();
              // Open view of IO product if specified in component props
              self.maybeOpenIoProduct();
            },
          );
        } else {
          self.setState({
            loading: false,
            refreshing: false,
          });
          Flagship.error(
            "Error getting IO products from Flagship API server.",
            recordId,
            self.props.userId,
          );
        }
      },
      function (err) {
        if (
          self.unmounted === true ||
          requestId !== self.latestIoProductsRequestId ||
          self.props.recordId !== recordId
        ) {
          return;
        }

        self.setState({
          loading: false,
          refreshing: false,
        });
        Flagship.error(
          "Error getting IO products from Flagship API server: " + err,
          recordId,
          self.props.userId,
        );
      },
    );
  }

  onViewIoProduct(e, data, item) {
    this.setState({
      viewingIoProduct: item,
    });
  }

  onEditIoProduct(e, data, item) {
    if (this.props.accessLevel !== 2) {
      return;
    }

    this.setState({
      editingIoProduct: item,
    });
  }

  swapToEdit() {
    if (this.props.accessLevel !== 2) {
      return;
    }

    let item = this.state.viewingIoProduct;
    let self = this;

    this.setState(
      {
        editingIoProduct: item,
      },
      function () {
        self.setState({
          viewingIoProduct: false,
        });
      },
    );
  }

  swapToView() {
    let item = this.state.editingIoProduct;
    let self = this;

    this.setState(
      {
        viewingIoProduct: item,
      },
      function () {
        self.setState({
          editingIoProduct: false,
        });
      },
    );
  }

  onAddNew() {
    if (this.props.accessLevel !== 2) {
      return;
    }

    this.setState({
      addingIoProduct: true,
    });
  }

  cancelAddNew() {
    this.setState({
      newIoProductService: null,
      newIoProductServiceNiceName: "",
      addingIoProduct: false,
    });
  }

  closeModals() {
    this.setState(
      {
        updatingPricing: false,
        viewingIoProduct: false,
        editingIoProduct: false,
        editingAssignee: false,
      },
      this.props.onCloseModals,
    );
  }

  onIoProductAddModalChange(ioProductData) {
    this.setState({
      newIoProductData: ioProductData,
    });
  }

  onAddIoProduct() {
    this.getIoProducts();
    this.setState({
      addingIoProduct: false,
    });
    if (typeof this.props.onAddIoProduct === "function") {
      this.props.onAddIoProduct();
    }
  }

  onUpdateIoProduct() {
    let self = this;
    this.setState(
      {
        editingIoProduct: false,
        editingAssignee: false,
        refreshing: true,
      },
      function () {
        self.getIoProducts();
      },
    );
  }

  onChangeProductStatus(i) {
    if (this.props.accessLevel !== 2) {
      return;
    }

    this.setState({
      editingProduct: i,
    });
  }

  onChangeAssignee(item) {
    if (this.props.accessLevel !== 2) {
      return;
    }

    this.setState({
      editingAssignee: item,
    });
  }

  onChangeProductStatusCancel() {
    this.setState({
      editingProduct: false,
    });
  }

  checkForIoStatusChanges() {
    if (this.props.recordType === "io") {
      let allIoProductsSubmitted = true;
      let allIoProductsLaunched = true;
      let allIoProductsStrategyApproved = true;
      let allIoProductsReceived = true;
      let allIoProductsComplete = true;
      let allIoProductsDead = true;
      let allIoProductsNew = true;
      let allIoProductsPaused = true;
      let someIoProductsNeedMaterials = false;
      let someIoProductsLaunched = false;

      if (this.state.ioProducts.length === 0) {
        allIoProductsDead = false;
        allIoProductsSubmitted = false;
        allIoProductsLaunched = false;
        allIoProductsPaused = false;
        allIoProductsReceived = false;
        allIoProductsStrategyApproved = false;
        allIoProductsNew = false;
        allIoProductsComplete = false;
        allIoProductsDead = false;
        this.props.updateLineItems([]);
      } else {
        this.props.updateLineItems(this.state.ioProducts);
        this.state.ioProducts.map(function (item) {
          if (item.status === "pending" || item.status === "draft") {
            allIoProductsStrategyApproved = false;
          }
          if (item.status !== "submitted" && item.status !== "trash") {
            allIoProductsSubmitted = false;
          }
          if (
            item.status !== "received" &&
            item.status !== "queued" &&
            item.status !== "submitted" &&
            item.status !== "launched" &&
            item.status !== "paused" &&
            item.status !== "complete" &&
            item.status !== "needs_materials" &&
            item.status !== "trash"
          ) {
            allIoProductsReceived = false;
          }
          if (item.status !== "launched" && item.status !== "trash") {
            allIoProductsLaunched = false;
          }
          if (item.status !== "paused" && item.status !== "trash") {
            allIoProductsPaused = false;
          }
          if (item.status !== "complete" && item.status !== "trash") {
            allIoProductsComplete = false;
          }
          if (item.status !== "trash") {
            allIoProductsDead = false;
          }
          if (item.status !== "publish") {
            allIoProductsNew = false;
          }
          if (item.status === "needs_materials") {
            someIoProductsNeedMaterials = true;
          }
          if (item.status === "launched") {
            someIoProductsLaunched = true;
          }
        });
      }

      let newStatus = this.props.recordStatus;

      if (newStatus !== "draft") {
        // Never update drafts

        if (allIoProductsStrategyApproved) {
          newStatus = "publish";
        } else {
          newStatus = "pending";
        }
        if (allIoProductsReceived === false && newStatus === "received") {
          // If all products were marked as received, but aren't anymore, revert to "strategy approved"
          newStatus = "publish";
        }

        if (allIoProductsDead === true && newStatus !== "draft") {
          newStatus = "trash";
        } else if (
          allIoProductsSubmitted === true &&
          allIoProductsDead === false
        ) {
          newStatus = "submitted";
        } else if (
          allIoProductsLaunched === true &&
          allIoProductsDead === false
        ) {
          newStatus = "launched";
        } else if (
          allIoProductsComplete === true &&
          allIoProductsDead === false
        ) {
          newStatus = "complete";
        } else if (
          allIoProductsPaused === true &&
          allIoProductsDead === false
        ) {
          newStatus = "paused";
        } else if (someIoProductsNeedMaterials === true) {
          newStatus = "needs_materials";
        } else if (someIoProductsLaunched === true) {
          newStatus = "mixed";
        } else if (
          allIoProductsReceived === true &&
          allIoProductsDead === false
        ) {
          newStatus = "received";
        } else if (allIoProductsNew === true && newStatus !== "draft") {
          newStatus = "publish";
        }
      }
      let onStatusChange = this.props.onStatusChange;

      if (this.props.accessLevel !== 2) {
        return;
      }

      if (
        newStatus !== this.props.recordStatus &&
        this.props.recordStatus === "trash"
      ) {
        Flagship.changeRecordStatus(
          this.props.recordId,
          newStatus,
          function () {
            Flagship.notify("IO reactivated based on product status.");
            onStatusChange();
          },
        );
      } else if (newStatus !== this.props.recordStatus) {
        Flagship.changeRecordStatus(
          this.props.recordId,
          newStatus,
          function () {
            Flagship.notify("Parent IO status updated automatically.");
            onStatusChange();
          },
        );
      }
    }
  }

  onChangeProductStatusConfirm(item, status) {
    if (this.props.accessLevel !== 2) {
      return;
    }

    let self = this;
    let id = item.id;

    this.setState(
      {
        savingIoProductChange: true,
      },
      function () {
        Flagship.post(
          "io-product/status/" + id,
          {
            status,
          },
          function (response) {
            if (response.data.success === true) {
              let allProducts = [...self.state.ioProducts];

              self.state.ioProducts.map(function (product, i) {
                if (product.id === id) {
                  let productCopy = Object.assign({}, allProducts[i]);
                  productCopy.status = response.data.new_status;
                  allProducts[i] = productCopy;
                }
              });

              self.setState(
                {
                  ioProducts: allProducts,
                },
                async function () {
                  self.checkForIoStatusChanges();

                  if (item.status !== response.data.new_status) {
                    Flagship.event(
                      "update-io-product-status",
                      {
                        ioProductId: item.id,
                        ioProductKey: item.io_product_key,
                        ioProductName: item.io_product_name,
                        oldStatus: item.status,
                        newStatus: response.data.new_status,
                      },
                      self.props.recordId,
                      self.props.userId,
                    );

                    if (response.data.new_status === "submitted") {
                      Flagship.notify("Submitted to Wrike for QA.");
                      Flagship.event(
                        "submit-io-product",
                        {
                          ioProductId: item.id,
                          ioProductKey: item.io_product_key,
                          ioProductName: item.io_product_name,
                          client: this.props.client,
                          assignee: item.assignee
                            ? item.first_name + " " + item.last_name
                            : "no one (unassigned)",
                          assigneeEmail: item.email,
                          oldStatus: item.status,
                          newStatus: response.data.new_status,
                        },
                        self.props.recordId,
                        self.props.userId,
                      );
                    } else if (response.data.new_status === "launched") {
                      Flagship.notify("Launched IO product.");

                      const campaigns = await self.getCampaigns(item.id);
                      const platforms = await self.getPlatforms();

                      const campaignsWithPlatforms = campaigns.map(
                        (campaign) => {
                          const platform = platforms.find(
                            (p) => p.key === campaign.platform_key,
                          );
                          return {
                            ...campaign,
                            platformName: platform ? platform.text : null,
                          };
                        },
                      );

                      Flagship.event(
                        "launch-io-product",
                        {
                          ioProductId: item.id,
                          ioProductKey: item.io_product_key,
                          ioProductName: item.io_product_name,
                          campaigns: campaignsWithPlatforms,
                          flights: item.flights,
                          market: this.props.market,
                          client: this.props.client,
                          assignee: item.assignee
                            ? item.first_name + " " + item.last_name
                            : "no one (unassigned)",
                          assigneeEmail: item.email,
                          oldStatus: item.status,
                          newStatus: response.data.new_status,
                        },
                        self.props.recordId,
                        self.props.userId,
                      );
                    } else if (response.data.new_status === "publish") {
                      // STRATEGY APPROVED

                      const campaigns = await self.getCampaigns(item.id);
                      const platforms = await self.getPlatforms();

                      const campaignsWithPlatforms = campaigns.map(
                        (campaign) => {
                          const platform = platforms.find(
                            (p) => p.key === campaign.platform_key,
                          );
                          return {
                            ...campaign,
                            platformName: platform ? platform.text : null,
                          };
                        },
                      );

                      // ONLY DO THIS FOR LOYOLA ACCOUNTS
                      if (
                        this.props.client ===
                          "Loyola University Medical Center" ||
                        this.props.client === "Loyola edu" ||
                        this.props.client === "Loyola University"
                      ) {
                        Flagship.event(
                          "approve-io-product",
                          {
                            ioProductId: item.id,
                            ioProductKey: item.io_product_key,
                            ioProductName: item.io_product_name,
                            campaigns: campaignsWithPlatforms,
                            flights: item.flights,
                            market: this.props.market,
                            client: this.props.client,
                            assignee: item.assignee
                              ? item.first_name + " " + item.last_name
                              : "no one (unassigned)",
                            assigneeEmail: item.email,
                            oldStatus: item.status,
                            newStatus: response.data.new_status,
                          },
                          self.props.recordId,
                          self.props.userId,
                        );

                        Flagship.notify("Product status updated.");
                      } else {
                        Flagship.notify("Product status updated.");
                      }
                    }
                  }
                },
              );
            } else {
              console.error(response.data);
              Flagship.error(
                "Failed to update product status.",
                self.props.recordId,
                self.props.userId,
              );
            }
            self.setState({
              savingIoProductChange: false,
              editingProduct: false,
            });
          },
        );
      },
    );
  }

  renderCriticalData(item, i) {
    return (
      <div key={i}>
        {!empty(item.flights) &&
        item.flights.length > 0 &&
        item.flights[0].hasOwnProperty("startDate") ? (
          <div className="io-product-dates">
            {item.io_product_type === "email-marketing" ? (
              <Label color="green">Deployment Date</Label>
            ) : (
              <div>
                {!empty(item.flights) ? (
                  <Label color="green">
                    {item.flights.length +
                      " Flight" +
                      (item.flights.length > 1 ? "s" : "")}
                  </Label>
                ) : null}
              </div>
            )}
            {item.flights.map(function (flight, i) {
              return (
                <div key={i} className="product-box-flight">
                  <Icon name="calendar" />
                  {getFormattedValue(moment(flight.startDate).unix(), "date")}
                  {typeof flight.endDate !== "undefined"
                    ? " - " +
                      getFormattedValue(moment(flight.endDate).unix(), "date")
                    : null}
                </div>
              );
            })}
          </div>
        ) : null}
      </div>
    );
  }

  renderAsTable() {
    let onEditIoProduct = this.onEditIoProduct;
    let editingProduct = this.state.editingProduct;
    let onChangeProductStatus = this.onChangeProductStatus;
    let onChangeProductStatusCancel = this.onChangeProductStatusCancel;
    let onChangeProductStatusConfirm = this.onChangeProductStatusConfirm;
    let onChangeAssignee = this.onChangeAssignee;
    let currentIoKey = this.props.recordKey;

    let self = this;

    return (
      <Table className="io-product-table">
        <Table.Body>
          {this.state.ioProducts.map(function (item, i) {
            let serviceNiceName = getServiceNiceName(item.io_product_type);

            if (editingProduct === i && self.props.accessLevel === 2) {
              let dropdownStatuses = [];

              for (let status in Flagship.config.records.io.ioProductStatuses) {
                dropdownStatuses.push({
                  key: status,
                  text: Flagship.config.records.io.ioProductStatuses[status]
                    .label,
                  color:
                    Flagship.config.records.io.ioProductStatuses[status].color,
                });
              }

              return (
                <Table.Row
                  key={"line-item-" + i}
                  className="single-io-product-table-row"
                >
                  <Table.Cell
                    className="main-column selecting-status-row"
                    colSpan={3}
                  >
                    <div className="select-new-status">
                      <h4 className="white-text">
                        {item.io_product_name}
                        <br />
                        <small>Select New Status...</small>
                      </h4>
                      {dropdownStatuses.map(function (item_b) {
                        return (
                          <Label
                            className="change-io-product-status-label"
                            key={item_b.key}
                            color={item_b.color}
                            content={item_b.text}
                            onClick={() => {
                              onChangeProductStatusConfirm(item, item_b.key);
                            }}
                          />
                        );
                      })}
                    </div>
                    <div className="cancel-button-container">
                      <Button
                        onClick={onChangeProductStatusCancel}
                        basic
                        size="small"
                        color="grey"
                        circular
                        className="cancel-button"
                        name="cancel"
                        content="Cancel"
                      />
                    </div>
                  </Table.Cell>
                </Table.Row>
              );
            }
            return (
              <Table.Row
                key={"line-item-" + i}
                className="single-io-product-table-row"
              >
                <Table.Cell className="main-column">
                  <Link
                    to={
                      "/io/view/" +
                      currentIoKey +
                      "/focus/" +
                      item.io_product_key
                    }
                    className="table-link"
                  >
                    {item.io_product_name}
                    {serviceNiceName !== item.io_product_name ? (
                      <div className="row-data-key">
                        ({serviceNiceName})<br />
                      </div>
                    ) : null}
                    <div className="row-data-key">
                      {item.io_product_key !== "" ? (
                        <Card.Meta>#{item.io_product_key}</Card.Meta>
                      ) : null}
                    </div>
                  </Link>
                </Table.Cell>
                <Table.Cell>
                  <Label
                    className="change-io-product-status-label"
                    color={
                      Flagship.config.records.io.ioProductStatuses[item.status]
                        .color
                    }
                    onClick={() => {
                      if (
                        self.props.userRole !== "ae" &&
                        self.props.userRole !== "dbs" &&
                        self.props.accessLevel === 2 &&
                        self.props.recordStatus !== "draft"
                      ) {
                        onChangeProductStatus(i);
                      }
                    }}
                  >
                    {Flagship.config.records.io.ioProductStatuses[item.status]
                      .label + " "}
                    {self.props.userRole !== "ae" &&
                    self.props.userRole !== "dbs" &&
                    self.props.accessLevel === 2 ? (
                      <Icon
                        name="caret down"
                        fitted
                        className="icon-down float-right"
                      />
                    ) : null}
                  </Label>
                </Table.Cell>
                <Table.Cell className="table-column-actions" textAlign="right">
                  <Popup
                    position="bottom left"
                    content="View"
                    trigger={
                      <Link
                        to={
                          "/io/view/" +
                          currentIoKey +
                          "/focus/" +
                          item.io_product_key
                        }
                        className="view-line-item"
                      >
                        <Icon name="eye" circular />
                      </Link>
                    }
                  />
                  {self.props.userRole !== "ae" &&
                  self.props.accessLevel === 2 ? (
                    <Popup
                      position="bottom left"
                      content="Edit"
                      trigger={
                        <Icon
                          name="edit"
                          circular
                          onClick={(e, data) => {
                            onEditIoProduct(e, data, item);
                          }}
                        />
                      }
                    />
                  ) : null}

                  <Popup
                    position="bottom left"
                    content={
                      empty(item.assignee)
                        ? "Unassigned"
                        : "Assigned to " +
                          item.first_name +
                          " " +
                          item.last_name
                    }
                    trigger={
                      empty(item.assignee) ? (
                        <Icon
                          color="black"
                          circular
                          name="user"
                          onClick={
                            self.props.accessLevel === 2
                              ? () => {
                                  onChangeAssignee(item);
                                }
                              : undefined
                          }
                        />
                      ) : (
                        <Image
                          src={
                            Flagship.config.uploads +
                            (!empty(item.photo) ? item.photo : "someone.png")
                          }
                          size="mini"
                          className="circular assignee-image"
                          onClick={
                            self.props.accessLevel === 2
                              ? () => {
                                  onChangeAssignee(item);
                                }
                              : undefined
                          }
                        />
                      )
                    }
                  />
                </Table.Cell>
              </Table.Row>
            );
          })}
        </Table.Body>
      </Table>
    );
  }

  renderIoProducts() {
    if (
      typeof this.state.ioProducts === "object" &&
      this.state.ioProducts.length === 0
    ) {
      return <div>No IO Products found.</div>;
    }

    let onEditIoProduct = this.onEditIoProduct;
    let renderCriticalData = this.renderCriticalData;
    let editingProduct = this.state.editingProduct;
    let onChangeProductStatus = this.onChangeProductStatus;
    let onChangeProductStatusCancel = this.onChangeProductStatusCancel;
    let onChangeProductStatusConfirm = this.onChangeProductStatusConfirm;
    let onChangeAssignee = this.onChangeAssignee;
    let savingIoProductChange = this.state.savingIoProductChange;
    let currentIoKey = this.props.recordKey;
    let userRole = this.props.userRole;
    let self = this;

    if (this.props.screenWidth >= 1030 && this.props.userViewAs === "list") {
      return this.renderAsTable();
    }

    return (
      <Card.Group>
        {this.state.ioProducts.map(function (item, i) {
          let serviceNiceName = getServiceNiceName(item.io_product_type);
          if (editingProduct === i && self.props.accessLevel === 2) {
            let dropdownStatuses = [];

            for (let status in Flagship.config.records.io.ioProductStatuses) {
              dropdownStatuses.push({
                key: status,
                text: Flagship.config.records.io.ioProductStatuses[status]
                  .label,
                color:
                  Flagship.config.records.io.ioProductStatuses[status].color,
              });
            }

            if (savingIoProductChange === true) {
              return (
                <Card key={"line-item-" + i} className="single-line-item">
                  <Card.Content>
                    <Card.Header>
                      <Header as="h4">{item.io_product_name}</Header>
                    </Card.Header>
                    <Card.Meta>Saving new status...</Card.Meta>
                    <Card.Content extra>
                      <Loader
                        color="blue"
                        className="flagship-loader"
                        active
                        inline="centered"
                      />
                    </Card.Content>
                  </Card.Content>
                </Card>
              );
            }

            return (
              <Card
                key={"line-item-" + i}
                className="single-line-item selecting-new-status"
              >
                <Card.Content>
                  <Card.Header>
                    <Header as="h4">{item.io_product_name}</Header>
                  </Card.Header>

                  <Card.Meta>Select a new status...</Card.Meta>
                  <Card.Description></Card.Description>
                  <Card.Content extra>
                    <div className="select-new-status">
                      {dropdownStatuses.map(function (item_b) {
                        return (
                          <Label
                            className="change-io-product-status-label"
                            key={item_b.key}
                            color={item_b.color}
                            content={item_b.text}
                            onClick={() => {
                              onChangeProductStatusConfirm(item, item_b.key);
                            }}
                          />
                        );
                      })}
                    </div>
                    <div className="cancel-button-container">
                      <Button
                        onClick={onChangeProductStatusCancel}
                        basic
                        size="small"
                        color="grey"
                        circular
                        className="cancel-button"
                        name="cancel"
                        content="Cancel"
                      />
                    </div>
                  </Card.Content>
                </Card.Content>
              </Card>
            );
          }

          return (
            <Card key={"line-item-" + i} className="single-line-item">
              <Card.Content>
                <Card.Header>
                  <Header as="h4">{item.io_product_name}</Header>
                </Card.Header>
                {serviceNiceName !== item.line_item_name ? (
                  <Card.Meta>
                    <small>({serviceNiceName})</small>
                  </Card.Meta>
                ) : null}
                <Card.Description>
                  {(userRole === "dpm" ||
                  userRole === "social" ||
                  userRole === "csm" ||
                  userRole === "admin") && self.props.accessLevel === 2 ? (
                    <div>
                      <Label
                        className="assignee-label"
                        onClick={() => {
                          onChangeAssignee(item);
                        }}
                      >
                        {empty(item.assignee) ? (
                          <div>
                            <Icon color="black" circular name="user" />
                            Unassigned
                            <Icon
                              name="caret down"
                              fitted
                              className="icon-down float-right"
                            />
                          </div>
                        ) : (
                          <div>
                            <Image
                              src={
                                Flagship.config.uploads +
                                (!empty(item.photo)
                                  ? item.photo
                                  : "someone.png")
                              }
                              size="mini"
                              className="circular assignee-image"
                            />
                            {item.first_name + " " + item.last_name}
                            <Icon
                              name="caret down"
                              fitted
                              className="icon-down float-right"
                            />
                          </div>
                        )}
                      </Label>

                      <Label
                        className="change-io-product-status-label"
                        color={
                          Flagship.config.records.io.ioProductStatuses[
                            item.status
                          ].color
                        }
                        onClick={() => {
                          onChangeProductStatus(i);
                        }}
                      >
                        {Flagship.config.records.io.ioProductStatuses[
                          item.status
                        ].label + " "}
                        <Icon
                          name="caret down"
                          fitted
                          className="icon-down float-right"
                        />
                      </Label>
                    </div>
                  ) : (
                    <div>
                      <Label className="assignee-label">
                        {empty(item.assignee) ? (
                          <div>
                            <Icon color="black" circular name="user" />
                            Unassigned
                          </div>
                        ) : (
                          <div>
                            <Image
                              src={
                                Flagship.config.uploads +
                                (!empty(item.photo)
                                  ? item.photo
                                  : "someone.png")
                              }
                              size="mini"
                              className="circular assignee-image"
                            />
                            {item.first_name + " " + item.last_name}
                          </div>
                        )}
                      </Label>

                      <Label
                        className="change-io-product-status-label"
                        color={
                          Flagship.config.records.io.ioProductStatuses[
                            item.status
                          ].color
                        }
                      >
                        {
                          Flagship.config.records.io.ioProductStatuses[
                            item.status
                          ].label
                        }
                      </Label>
                    </div>
                  )}
                </Card.Description>
                <Card.Content extra>{renderCriticalData(item, i)}</Card.Content>
              </Card.Content>
              <Card.Content extra>
                {userRole !== "ae" && self.props.accessLevel === 2 ? (
                  <div className="ui two buttons line-item-actions">
                    <Link
                      to={
                        "/io/view/" +
                        currentIoKey +
                        "/focus/" +
                        item.io_product_key
                      }
                    >
                      <Button basic primary>
                        View
                      </Button>
                    </Link>
                    <Button
                      basic
                      secondary
                      onClick={(e, data) => {
                        onEditIoProduct(e, data, item);
                      }}
                    >
                      Edit
                    </Button>
                  </div>
                ) : (
                  <div className="ui">
                    <Link
                      to={
                        "/io/view/" +
                        currentIoKey +
                        "/focus/" +
                        item.io_product_key
                      }
                    >
                      <Button primary>View Product Details...</Button>
                    </Link>
                  </div>
                )}
              </Card.Content>
            </Card>
          );
        })}
      </Card.Group>
    );
  }

  renderViewIoProductModal() {
    if (this.state.viewingIoProduct === false) {
      return null;
    } else {
      return (
        <IoProductViewModal
          open={true}
          cancelUpdate={this.closeModals.bind(this)}
          ioProductId={
            !empty(this.state.viewingIoProduct.id)
              ? this.state.viewingIoProduct.id
              : false
          }
          client={this.props.client}
          market={this.props.market}
          tier={this.props.tier}
          recordId={this.props.recordId}
          ioProduct={this.state.viewingIoProduct}
          swapToEdit={this.swapToEdit}
          onChangeAssignee={this.onChangeAssignee}
          onChangeProductStatus={this.onChangeProductStatus}
          userRole={this.props.userRole}
          accessLevel={this.props.accessLevel}
        />
      );
    }
  }

  renderEditIoProductModal() {
    if (
      this.props.accessLevel !== 2 ||
      this.state.editingIoProduct === false
    ) {
      return null;
    } else {
      return (
        <IoProductEditModal
          open={true}
          cancelUpdate={this.closeModals.bind(this)}
          ioProductId={
            !empty(this.state.editingIoProduct.id)
              ? this.state.editingIoProduct.id
              : false
          }
          recordId={this.props.recordId}
          ioProduct={this.state.editingIoProduct}
          swapToView={this.swapToView}
          onChange={this.onIoProductEditModalChange}
          onUpdateIoProduct={this.onUpdateIoProduct}
          accessLevel={this.props.accessLevel}
        />
      );
    }
  }

  renderAddIoProductModal() {
    if (this.props.accessLevel !== 2 || this.state.addingIoProduct === false) {
      return null;
    } else {
      return this.props.isAdvisr ? (
        <IoProductAdvisrAddModal
          isAdvisr={this.props.isAdvisr}
          open={true}
          cancelAddNew={this.cancelAddNew.bind(this)}
          recordId={this.props.recordId}
          onChange={this.onIoProductAddModalChange}
          name={this.state.newIoProductName}
          service={this.state.newIoProductService}
          serviceNiceName={this.state.newIoProductServiceNiceName}
          newIoProductService={this.state.newIoProductService}
          onAddIoProduct={this.onAddIoProduct}
          accessLevel={this.props.accessLevel}
        />
      ) : (
        <IoProductAddModal
          isAdvisr={this.props.isAdvisr}
          open={true}
          cancelAddNew={this.cancelAddNew.bind(this)}
          recordId={this.props.recordId}
          onChange={this.onIoProductAddModalChange}
          name={this.state.newIoProductName}
          service={this.state.newIoProductService}
          serviceNiceName={this.state.newIoProductServiceNiceName}
          newIoProductService={this.state.newIoProductService}
          onAddIoProduct={this.onAddIoProduct}
          accessLevel={this.props.accessLevel}
        />
      );
    }
  }

  renderAssignIoProductModal() {
    if (this.props.accessLevel !== 2 || this.state.editingAssignee === false) {
      return null;
    } else {
      return (
        <IoProductAssignModal
          open={true}
          recordId={this.props.recordId}
          data={this.state.editingAssignee}
          onChange={this.onChangeAssignee}
          cancelUpdate={this.closeModals.bind(this)}
          onUpdateIoProduct={this.onUpdateIoProduct}
          onChangeAssignee={this.props.onChangeAssignee}
          accessLevel={this.props.accessLevel}
        />
      );
    }
  }

  changeViewAs(e, data) {
    this.props.actions.changeViewAs(data.value);

    // Update user preference in DB
    Flagship.post("user-view-as/" + this.props.userId, { viewAs: data.value });
  }

  render() {
    if (this.props.parentMode === "view") {
      return (
        <div className="line-item-box">
          <Divider hidden />
          <Header as="h3">
            IO Products
            <Dropdown
              text="View As..."
              className="change-view-as"
              options={[
                {
                  key: "cards",
                  value: "cards",
                  text: "Cards",
                },
                {
                  key: "list",
                  value: "list",
                  text: "List",
                },
              ]}
              onChange={this.changeViewAs}
            />
          </Header>
          {this.state.loading === true ? (
            <Loader
              color="blue"
              className="flagship-loader"
              active
              inline="centered"
            />
          ) : (
            <div>
              {this.renderIoProducts()}
              <br />
              {this.props.accessLevel === 2 &&
              this.props.userRole !== "ae" &&
              (this.props.isAdvisr || this.props.instance === "SHIFT") &&
              this.props.recordStatus !== "trash" ? (
                <Button
                  primary
                  icon="plus"
                  content="Add a Product"
                  onClick={this.onAddNew}
                />
              ) : (
                <div className="gray-text">
                  You cannot add products to this IO.
                </div>
              )}
              <br />
            </div>
          )}
          {this.renderAddIoProductModal()}
          {this.renderViewIoProductModal()}
          {this.renderEditIoProductModal()}
          {this.renderAssignIoProductModal()}
        </div>
      );
    } else {
      return null;
    }
  }
}

IoProductBox.propTypes = {
  actions: PropTypes.object,
  username: PropTypes.string,
  userId: PropTypes.number,
  userRole: PropTypes.string,
  instance: PropTypes.string,
};

function mapStateToProps(state) {
  return {
    username: state.main.username,
    userId: state.main.userId,
    userRole: state.main.userRole,
    userViewAs: state.main.userViewAs,
    screenWidth: state.main.screenWidth,
    instance: state.main.instance,
    accessLevel: state.main.accessLevel,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(IoProductBox);



// WEBPACK FOOTER //
// ./src/components/misc/IoProductBox.js